export default __webpack_public_path__ + "static/media/empoty-file.6009093a.svg";